<ion-modal class="pwa-install-modal" [isOpen]="pwa.isModalVisible()" [canDismiss]="true" [backdropDismiss]="false"
  (didDismiss)="onDidDismiss()">
  <ng-template>
    <div class="pwa-install-panel" role="dialog" aria-modal="true">
      <div class="pwa-install-panel__glow" aria-hidden="true"></div>

      <div class="pwa-install-icon" aria-hidden="true">
        <ion-icon [name]="pwa.installMode() === 'ios' ? 'share-outline' : 'phone-portrait-outline'"></ion-icon>
      </div>

      <div class="pwa-install-brand">
        <re-app-brand-logo size="compact" variant="icon" />
      </div>
      <h2 class="pwa-install-title">
        @if (pwa.installMode() === 'ios') {
        {{ 'common.pwaInstallIosTitle' | translate }}
        } @else {
        {{ 'common.pwaInstallTitle' | translate }}
        }
      </h2>
      <div class="pwa-install-divider" aria-hidden="true"></div>

      @if (pwa.installMode() === 'ios') {
      <ol class="pwa-install-steps">
        <li>{{ 'common.pwaInstallIosStep1' | translate }}</li>
        <li>{{ 'common.pwaInstallIosStep2' | translate }}</li>
        <li>{{ 'common.pwaInstallIosStep3' | translate }}</li>
      </ol>
      } @else {
      <p class="pwa-install-lead">{{ 'common.pwaInstallLead' | translate }}</p>
      <ul class="pwa-install-benefits">
        <li>
          <ion-icon name="notifications-outline" aria-hidden="true"></ion-icon>
          <span>{{ 'common.pwaInstallBenefitNotifications' | translate }}</span>
        </li>
        <li>
          <ion-icon name="home-outline" aria-hidden="true"></ion-icon>
          <span>{{ 'common.pwaInstallBenefitHome' | translate }}</span>
        </li>
        <li>
          <ion-icon name="expand-outline" aria-hidden="true"></ion-icon>
          <span>{{ 'common.pwaInstallBenefitFullscreen' | translate }}</span>
        </li>
      </ul>
      }

      <div class="pwa-install-actions">
        @if (pwa.installMode() === 'native') {
        <ion-button class="pwa-install-action pwa-install-action--primary" expand="block" (click)="pwa.installPrompt()">
          {{ 'common.pwaInstallBtn' | translate }}
        </ion-button>
        } @else {
        <ion-button class="pwa-install-action pwa-install-action--primary" expand="block" (click)="pwa.closeModal()">
          {{ 'common.pwaInstallIosDone' | translate }}
        </ion-button>
        }
        <ion-button class="pwa-install-action pwa-install-action--secondary" expand="block" fill="clear"
          (click)="pwa.dismissLater()">
          {{ 'common.pwaInstallLater' | translate }}
        </ion-button>
      </div>
    </div>
  </ng-template>
</ion-modal>